import { featuredComics } from '@/mocks/comics';

interface ArticleHeroProps {
  comicId: number;
}

export default function ArticleHero({ comicId }: ArticleHeroProps) {
  const comic = featuredComics.find((c) => c.id === comicId) || featuredComics[0];

  return (
    <section className="relative w-full h-[420px] md:h-[550px] overflow-hidden">
      <img
        src={comic.cover}
        alt={comic.title}
        title={`${comic.title} - 韩漫漫画网`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-primary-500/20 via-accent-500/10 to-transparent"></div>
      </div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 text-center leading-tight mb-2 whitespace-nowrap">
          {comic.title}
        </h2>
        <p className="text-base md:text-xl font-heading italic text-background-50/90 text-center mb-3 whitespace-nowrap">
          {comic.author} · {comic.category}
        </p>
        <p className="text-sm md:text-base text-background-50/70 text-center max-w-lg mb-8 leading-relaxed">
          {comic.description}
        </p>
        <button className="px-10 py-3 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer">
          开始阅读
        </button>
        <div className="flex items-center gap-6 mt-6">
          <span className="text-xs text-background-50/70 whitespace-nowrap">⭐ {comic.rating}分</span>
          <span className="text-xs text-background-50/70 whitespace-nowrap">📖 {comic.chapters}话</span>
          <span className="text-xs text-background-50/70 whitespace-nowrap">👁 {comic.views}</span>
          <span className="text-xs text-background-50/70 whitespace-nowrap">{comic.status}</span>
        </div>
      </div>
    </section>
  );
}